import { BRAND } from "../lib/brand";
import { ArrowRight } from "lucide-react";

export const Hero = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden grain"
    >
      <img
        src="https://static.prod-images.emergentagent.com/jobs/04aafec5-89a2-40fb-8913-69408800e0f1/images/0a00fd0dac21aa8e5d2f07b67c0aece441eb4e56299ccd2fcff2ca29a313cb09.png"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-navy/40" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12 w-full pt-28">
        <div className="max-w-3xl">
          <p className="reveal uppercase tracking-[0.3em] text-xs font-semibold text-gold mb-6">
            Business &amp; Management Consulting
          </p>
          <h1
            className="reveal font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight"
            style={{ animationDelay: "0.1s" }}
          >
            We turn <span className="gold-text">complexity</span> into clarity—and clarity into confidence.
          </h1>
          <p
            className="reveal mt-8 text-lg text-slate-300 max-w-xl leading-relaxed"
            style={{ animationDelay: "0.25s" }}
          >
            Six12 Consulting is the strategic partner for leaders navigating high-stakes decisions.
            We examine every angle, separate signal from noise, and deliver the insight that drives results.
          </p>
          <div className="reveal mt-10 flex flex-wrap gap-4" style={{ animationDelay: "0.4s" }}>
            <button
              data-testid="hero-book-btn"
              onClick={() => go("#contact")}
              className="group inline-flex items-center gap-2 bg-gold text-navy font-semibold uppercase tracking-wider text-sm px-8 py-4 hover:bg-gold-soft transition-colors"
            >
              Book a Consultation
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid="hero-services-btn"
              onClick={() => go("#services")}
              className="inline-flex items-center gap-2 border border-gold/60 text-gold font-semibold uppercase tracking-wider text-sm px-8 py-4 hover:bg-gold hover:text-navy transition-colors"
            >
              Explore Services
            </button>
          </div>

          <div className="reveal mt-16 flex flex-wrap gap-x-8 gap-y-3" style={{ animationDelay: "0.55s" }}>
            {BRAND.pillars.map((p) => (
              <span key={p} className="text-xs uppercase tracking-[0.2em] text-slate-400">
                {p}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
